import { ReactComponent as Free } from 'assets/PlansIcons/F.svg';
import { ReactComponent as Busy } from 'assets/PlansIcons/B.svg';
import { ReactComponent as Moderate } from 'assets/PlansIcons/M.svg';
import { ReactComponent as Unlimited } from 'assets/PlansIcons/U.svg';
import useStyles from './styles';

type PlanName = 'Free' | 'Busy' | 'Moderate' | 'Unlimited';

interface Props {
  planName: PlanName;
  height?: number;
}

const ICONS = {
  Free,
  Busy,
  Moderate,
  Unlimited,
};

export default function PlanIcon({ planName, height = 30 }: Props) {
  const styles = useStyles();

  const Icon = ICONS[planName];

  if (!Icon) return null;

  return <Icon className={styles.icon} height={height} />;
}